<!--
  So renderiza quando ha alguma pendencia (contrato ou despesa). Enquanto
  carrega, ou quando nao ha nada pendente, o card fica oculto para nao
  poluir o dashboard de quem nao usa contador.
-->
<div *ngIf="carregado && temPendencias"
     class="notif-card notif-card-clicavel"
     role="button"
     tabindex="0"
     (click)="verDetalhes()"
     (keyup.enter)="verDetalhes()"
     (keydown.space)="verDetalhes(); $event.preventDefault()">

  <div class="card-header">
    <div class="header-left">
      <i class="pi pi-bell"></i>
      <span class="header-titulo">{{ texts.titulo }}</span>
      <p-badge [value]="totalPendencias" severity="danger"></p-badge>
    </div>
    <i class="pi pi-chevron-right header-chevron" aria-hidden="true"></i>
  </div>

  <p-divider></p-divider>

  <p class="notif-subtitulo">{{ texts.subtitulo }}</p>

  <div class="notif-itens">
    <!-- Solicitacoes de contrato pendentes -->
    <div class="notif-item" *ngIf="contratosPendentes > 0">
      <div class="notif-item__icone notif-item__icone--contrato">
        <i class="pi pi-file-edit"></i>
      </div>
      <div class="notif-item__texto">
        <span class="notif-item__valor">{{ contratosPendentes }}</span>
        <span class="notif-item__label">{{ texts.contratos_label }}</span>
      </div>
    </div>

    <!-- Despesas acessorias pendentes (com destaque IVA) -->
    <div class="notif-item" *ngIf="despesasPendentes > 0">
      <div class="notif-item__icone notif-item__icone--despesa">
        <i class="pi pi-wallet"></i>
      </div>
      <div class="notif-item__texto">
        <span class="notif-item__valor">{{ despesasPendentes }}</span>
        <span class="notif-item__label">{{ texts.despesas_label }}</span>
        <span class="notif-item__iva" *ngIf="despesasIva > 0">
          <i class="pi pi-percentage"></i>
          {{ 'notificacoes.card.iva_label' | translate: { count: despesasIva } }}
        </span>
      </div>
    </div>
  </div>

  <div class="notif-rodape">
    <span class="notif-rodape__acao">{{ texts.ver_detalhes }}</span>
    <i class="pi pi-arrow-right" aria-hidden="true"></i>
  </div>
</div>
